import { PlainObject } from "../models";

export const Url = Object.freeze({
    getQueryParams<T extends PlainObject>(input: string): T {
        try {
            // 1. Try to parse as a full URL. 
            // If it's a relative path, this will throw an error.
            const url = new URL(input);
            return Object.fromEntries(url.searchParams) as T;
        } catch {
            // 2. If it's not a full URL, treat it as a potential query string.
            // We look for the first '?' to start parsing.
            const queryString = input.includes('?') ? input.split('?')[1] : input;
            const params = new URLSearchParams(queryString);

            // Convert to a plain object
            return Object.fromEntries(params) as T;
        }
    }
});